import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient, {publicAxiosClient} from '../AxiosClient'

export const loginAsync = createAsyncThunk(
  'auth/loginAsync',
  async function (
    payload: {email: string; password: string; otp?: string; 'g-recaptcha-response'?: string},
    toolkit
  ) {
    return await AxiosClient('POST', '/api/token2/', payload, toolkit, [])
  }
)



export const validateUserSessionGetAsync = createAsyncThunk(
  'validate/user/session',
  async function (payload: {session_token:string,otp?:string}, toolkit) {
    return await AxiosClient('POST', '/user/validate-session-token', payload, toolkit, [])
  }
  
)


export const validateUserSessionPostAsync = createAsyncThunk(
  'validate/user/session',
  async function (payload: {session_token:string,otp?:string,password?:string}, toolkit) {
    return await AxiosClient('POST', '/user/validate-user-session', payload, toolkit, [])
  }
  
)


export const googleLoginAsync = createAsyncThunk(
  'auth/googleLoginAsync',
  async function (payload: {token: string,  source?: string}, toolkit) {
    return await AxiosClient('POST', '/user/google-oauth-login', payload, toolkit, [])
  }
)

export const registrationAsync = createAsyncThunk(
  'auth/registrationAsync',
  async function (
    payload: {
      name: string|null
      email: string|null
      password: string
      user_type: 'USER'
      is_superuser: boolean
      is_staff: boolean
      is_active: boolean
      invited_by:number|null
      source:string|null
      application_id?: string | null
      add_staff_user?: string | null
      'g-recaptcha-response'?: string
    
    },
    toolkit
  ) { 
    return await publicAxiosClient('POST', '/user/register', payload, toolkit, [])
  }
)

export const logoutAsync = createAsyncThunk(
  'auth/logoutAsync',
  async function (payload: {email: string; password: string}, toolkit) {
    return await AxiosClient('POST', '/user/logout', payload, toolkit, [])
  }
)

export const verifyRegistrationAsync = createAsyncThunk(
  'auth/verifyRegistrationAsync',
  async function (payload: {activation_token: string}, toolkit) {
    return await AxiosClient('POST', '/user/activate-user', payload, toolkit, [])
  }
)
// ReDirect to Commercium From Disconnect
export const loginByURL = createAsyncThunk(
  'auth/redirectToCommercium',
  async function (payload: {token: string}, toolkit) {
    return await AxiosClient('POST', '/user/oauth/login-with-token', payload, toolkit, [])
  }
)

export const getURL = createAsyncThunk(
  'auth/getURL',
  async function (payload, toolkit) {
    return await AxiosClient('GET', '/api/open-disconnect-shopifyapp-login', [], toolkit, [])
  }
)

//forgetpassword

export const requestPasswordForgetAsync = createAsyncThunk(
  'auth/requestPasswordForgetAsync',
  async function (
    payload: {
      email: string
      'g-recaptcha-response'?: string
    },
    toolkit
  ) {
    return await publicAxiosClient('POST', '/user/request-forgot-password', payload, toolkit, [])
  }
)



export const verifyForgetPasswordAsync = createAsyncThunk(
  'auth/verifyForgetPasswordAsync',
  async function (payload: {forgot_password_token: string}, toolkit) {
    return await AxiosClient('POST', '/user/verify-forgot-password', payload, toolkit, [])
  }
)
//updateForgottenPasswordAsync

export const updateForgottenPasswordAsync = createAsyncThunk(
  'auth/updateForgottenPasswordAsync',
  async (payload:{forgot_password_token: string;password:string;confirm_password:string}, toolkit) => {
    return await AxiosClient('POST', '/user/update-forgotten-password', payload, toolkit, []);
  }
);

export const activateRoleUserAccountAsync = createAsyncThunk(
  'auth/activateRoleUserAccountAsync',
  async (
    payload: {activation_token: string; password: string; confirm_password: string},
    toolkit
  ) => {
    return await AxiosClient('POST', '/superadmin/role-user-activate', payload, toolkit, []);
  }
);

export const checkShopifyUserExistence = createAsyncThunk(
  'auth/checkShopifyUserExistence',
  async (params:{shop:string}, toolkit) => {
    return await AxiosClient('GET', '/shopify-user-existence', [], toolkit, params );
  }
);

export const requestForShopifyOauthUrlAsync = createAsyncThunk(
  'auth/requestForShopifyOauthUrlAsync',
  async (params:{ available_platform:string,client_id:string, redirect_uri:string, scope:string, shop:string}, toolkit) => {
    return await AxiosClient('GET', '/shopify-oauth-url', [], toolkit, params );
  }
);

export const handleShopifyOauthCallbackAsync = createAsyncThunk(
  'auth/handleShopifyOauthCallbackAsync',
  async (payload:{ body: any, params:{code:string} }, toolkit) => {
    return await AxiosClient('POST', '/handle-shopify-oauth-callback', payload.body, toolkit, payload.params );
  }
)

export const handleOauthForConnectPlatformAsync = createAsyncThunk(
  'auth/handleOauthForConnectPlatformAsync',
  async (params:any, toolkit) => {
    return await AxiosClient('GET', '/oauth-url', [], toolkit, params );
  }
)

export const refreshOauthForConnectPlatformAsync = createAsyncThunk(
  'auth/refreshOauthForConnectPlatformAsync',
  async (params:any, toolkit) => {
    return await AxiosClient('GET', '/refresh-oauth-url', [], toolkit, params );
  }
)

export const refreshTokenOauthUrlHandleAsync = createAsyncThunk(
  'auth/refreshTokenOauthUrlHandleAsync',
  async (params:any, toolkit) => {
    return await AxiosClient('GET', '/refresh-token', [], toolkit, params );
  }
)

export const refreshOauthCallbackAsync = createAsyncThunk(
  'auth/refreshOauthCallbackAsync',
  async (params:any, toolkit) => {
    console.log('params', params)
    return await AxiosClient('GET', '/refresh-token-callback', [], toolkit, params );
  }
)

export const handleOauthCallbackAsync = createAsyncThunk(
  'auth/handleOauthCallbackAsync',
  async (params:any, toolkit) => {
    console.log('params', params)
    return await AxiosClient('GET', '/handle-oauth-callback', [], toolkit, params );
  }
)

export const handleAppInstallationAsync = createAsyncThunk(
  'auth/handleAppInstallationAsync',
  async (params:any, toolkit) => {
    return await AxiosClient('GET', '/handle-app-installation', [], toolkit, params );
  }
)

export const handleAppAfterInstallationAsync = createAsyncThunk(
  'auth/handleAppAfterInstallationAsync',
  async (payload:any, toolkit) => {
    return await AxiosClient('POST', '/handle-app-after-installation', payload, toolkit, [] );
  }
)

export const userOauthLoginAsync = createAsyncThunk(
  'auth/userOauthLoginAsync',
  async (payload:any, toolkit) => {
    return await AxiosClient('POST', '/user/oauth/login', payload, toolkit, [] );
  }
)

export const getUserReportsAsync = createAsyncThunk(
  'auth/getUserReportsAsync',
  async (params:any, toolkit) => {
    return await AxiosClient('GET', `/user/user-platforms-report`, [], toolkit, params );
  }
)

export const getSalesByChannelAsync = createAsyncThunk(
  'auth/getSalesByChannelAsync',
  async (
    params: {
      user_id: number
      filter_type: 'last_7_days' | 'last_30_days' | 'this_month' | 'today' | 'this_week'
    },
    toolkit
  ) => {
    return await AxiosClient('GET', '/api/reports/sales-by-channel', [], toolkit, params)
  }
)

export const getReportFilterTypesAsync = createAsyncThunk(
  'auth/getReportFilterTypesAsync',
  async (_: void, toolkit) => {
    return await AxiosClient('GET', '/api/reports/filter-types', [], toolkit, [])
  }
)

export const getTopStockedItemsAsync = createAsyncThunk(
  'auth/getTopStockedItemsAsync',
  async (
    params: {
      user_id: number
      view_by: 'value' | 'quantity'
      filter_type: 'last_7_days' | 'last_30_days' | 'this_month' | 'today' | 'this_week'
      page_num: number
      page_limit: number
    },
    toolkit
  ) => {
    return await AxiosClient('GET', '/api/reports/top-stocked-items', [], toolkit, params)
  }
)


export const setInitialPopupDataAsync = createAsyncThunk(
  'auth/setInitialPopupDataAsync',
  async (payload:{isOnboardingProcessCompleted:boolean}, toolkit) => {
    return await AxiosClient('POST', `/user/initial-platform-connection-popup`, payload, toolkit, [] );
  }
)

export const setPlatformChoiceAsync = createAsyncThunk(
  'auth/setPlatformChoiceAsync',
  async (payload:any, toolkit) => {
    return await AxiosClient('POST', `/user/platform-choice`, payload, toolkit, [] );
  }
)

export const userLoginUsingInstanceAsync = createAsyncThunk(
  'auth/userLoginUsingInstanceAsync',
  async (params:any, toolkit) => {
    return await AxiosClient('GET', `/wix-autologin`, [], toolkit, params );
  }
)

export const getDashboardNewsAsync = createAsyncThunk(
  'auth/getDashboardNewsAsync',
  async (params:any, toolkit) => {
    return await AxiosClient('GET', `/notifications-get`, [], toolkit, params );
  }
)

export const getDashboardComingSoonAsync = createAsyncThunk(
  'auth/getDashboardComingSoonAsync',
  async (_: void, toolkit) => {
    return await AxiosClient('GET', '/notifications-get', [], toolkit, {
      type: 'COMING_SOON',
      status: 'published',
      page: 1,
      limit: 10,
    })
  }
)

export const getDashboardStatDataAsync = createAsyncThunk(
  'auth/getDashboardStatDataAsync',
  async (params:any, toolkit) => {
    return await AxiosClient('GET', `/user/user-platforms-stats`, [], toolkit, params );
  }
)

export const getInitialSyncStatusAsync = createAsyncThunk(
  'auth/getInitialSyncStatusAsync',
  async (params:any, toolkit) => {
    return await AxiosClient('GET', `/user/initial-platform-sync`, [], toolkit, params );
  }
)

export const userPhoneNumberAsync = createAsyncThunk(
  'auth/userPhoneNumberAsync',
  async (params:any, toolkit) => {
    return await AxiosClient('POST', '/api/user-contact-info', [], toolkit, params );
  }
)

export const getAccountSetupProgressAsync = createAsyncThunk(
  'auth/getAccountSetupProgressAsync',
  async (params: {user_id: string | number}, toolkit) => {
    return await AxiosClient('GET', '/user/account-setup-progress', [], toolkit, params);
  }
)
